const s = /^[^\s][a-zA-Z0-9-`.':()[\],&?®|\s]*$/;
export {
  s as FORM_VALIDATION_REGEX
};
